import { capitalize, titleize } from 'HELPERS/text';

export default class LokaliseLanguage {
  constructor() {
    this.localLanguage = {};
    
  }

  load = (lang = null) => new Promise(async (resolve, reject) => {

      let url;
      if(__ENV__ == 'local') url = '.';
      if(__ENV__ == 'development') url = `${window.location.origin}${window.location.pathname}`;
      if(__ENV__ == 'production') url = 'https://stp.preferabli.com';
// 
      const localeFetch = await fetch(`${url}/locale/${lang}.json`, { 
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
      });

      const _lang = await localeFetch.json();

      if(_lang){
        this.localLanguage = _lang;
        resolve();
      }

  });

  getSlugTranslation = ({ slug, secondary_slug = null, canTitleize = false }) => {
     const isEmpty = v => v === '' || v === null || typeof v === 'undefined';

     const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

     if (!isEmpty(slug) && has(this.localLanguage, slug)) {
       let out = this.localLanguage[slug];
       return canTitleize ? titleize(out) : out;
     }

     if (!isEmpty(secondary_slug) && has(this.localLanguage, secondary_slug)) {
       let out = this.localLanguage[secondary_slug];
       return canTitleize ? titleize(out) : out;
     }

     return '';
  };
  
}